function getSubscriptionLayout() {
  return window.KR_PRODUCT_SUBSCRIPTION_LAYOUT || 'dog_size';
}

function isEnglishPage() {
  const htmlLang = document.documentElement.lang?.toLowerCase() || '';
  const shopifyLocale = window.Shopify?.locale?.toLowerCase() || '';

  return htmlLang.startsWith('en') || shopifyLocale.startsWith('en');
}

function t(key) {
  const translations = {
    es: {
      oneTimePurchase: 'Compra única',
      subscribeAndSave: 'Suscríbete y Ahorra',
      bestOffer: 'Mejor Oferta',
      mostPopular: 'Más Popular',
      chooseDogWeight: 'Elige el peso de tu perro',
      small: 'Pequeño',
      medium: 'Mediano',
      large: 'Grande',
      subscription: 'Suscripción',
      receiveEvery: 'Recibe cada',
      days: 'días',
      benefit1: 'Tu perro nunca se queda<br>sin su producto',
      benefit2: 'Entrega rápida<br>y gratis',
      benefit3: 'Los mejores<br>precios, siempre',
      benefit4: 'Cancela en<br>cualquier momento'
    },
    en: {
      oneTimePurchase: 'One-time purchase',
      subscribeAndSave: 'Subscribe & Save',
      bestOffer: 'Best Value',
      mostPopular: 'Most Popular',
      chooseDogWeight: "Choose your dog's weight",
      small: 'Small',
      medium: 'Medium',
      large: 'Large',
      subscription: 'Subscription',
      receiveEvery: 'Delivered every',
      days: 'days',
      benefit1: "Your dog's favorites,<br>always on hand",
      benefit2: 'Free & fast<br>shipping',
      benefit3: 'Save on every<br>order',
      benefit4: 'Cancel<br>anytime'
    }
  };

  return isEnglishPage() ? translations.en[key] : translations.es[key];
}

function updateSubscriptionText() {
  const oneTimeText = document.querySelector(
    '.shopify_subscriptions_app_block .one_time_purchase_option_app_block span'
  );

  if (oneTimeText) {
    oneTimeText.textContent = t('oneTimePurchase');
  }

  const subscribeTitle = document.querySelector(
    '.shopify_subscriptions_app_block .subscription_group:last-child .group_name'
  );

  if (subscribeTitle) {
    const discountMatch = subscribeTitle.textContent.match(/(\d+)\s*%/);
    const discount = discountMatch ? discountMatch[1] : '20';
    subscribeTitle.textContent = `${t('subscribeAndSave')} ${discount}%`;
  }
}

function getFrequencyFromText(text) {
  if (!text) return null;

  const cleanText = text.toLowerCase();

  const daysMatch = cleanText.match(/(?:cada|every)\s+(\d+)?\s*(día|dias|días|day|days)/i);
  if (daysMatch) {
    return Number(daysMatch[1] || 1);
  }

  const weeksMatch = cleanText.match(/(?:cada|every)\s+(\d+)?\s*(semana|semanas|week|weeks)/i);
  if (weeksMatch) {
    return Number(weeksMatch[1] || 1) * 7;
  }

  const monthMatch = cleanText.match(/(?:cada|every)\s+(\d+)?\s*(mes|meses|month|months)/i);
  if (monthMatch) {
    return Number(monthMatch[1] || 1) * 30;
  }

  const yearMatch = cleanText.match(/(?:cada|every)\s+(\d+)?\s*(año|años|year|years)/i);
  if (yearMatch) {
    return Number(yearMatch[1] || 1) * 365;
  }

  return null;
}

function updateSubscriptionLabels() {
  const layout = getSubscriptionLayout();

  const options = document.querySelectorAll(
    '.shopify_subscriptions_app_block .group_list_item input[data-radio-type="selling_plan"]'
  );

  options.forEach((input, index) => {
    const label = input.closest('.group_list_item');
    const span = label?.querySelector('span');
    const text = input.getAttribute('aria-label') || span?.textContent || '';
    const days = getFrequencyFromText(text);

    if (!span) return;

    if (layout === 'dog_size') {
  const sizeLabels = [t('small'), t('medium'), t('large')];

  const sizeRanges = isEnglishPage()
    ? ['(0–22 lb)', '(23–66 lb)', '(67+ lb)']
    : ['(0–10 kg)', '(11–30 kg)', '(30+ kg)'];

  span.innerHTML = `
    <strong>${sizeLabels[index] || t('subscription')} ${sizeRanges[index] || ''}</strong><br>
    ${t('receiveEvery')} ${days || ''} ${t('days')}
  `;
}


    if (layout === 'frequency_only') {
      span.innerHTML = `
        <strong>${t('receiveEvery')} ${days || ''} ${t('days')}</strong>
      `;
    }
  });
}

function addDogWeightTitle() {
  const layout = getSubscriptionLayout();

  if (layout !== 'dog_size') return;

  const groupList = document.querySelector(
    '.shopify_subscriptions_app_block .group_list'
  );

  if (!groupList) return;

  let title = document.querySelector('.dog-weight-title');

  if (!title) {
    title = document.createElement('div');
    title.className = 'dog-weight-title';
    groupList.parentNode.insertBefore(title, groupList);
  }

  title.textContent = t('chooseDogWeight');
}

function removeSubscriptionPolicy() {
  const policy = document.querySelector('.shopify_subscriptions_app_policy');
  if (policy) policy.remove();
}

function addSubscriptionTextClasses() {
  const oneTime = document.querySelector(
    '.shopify_subscriptions_app_block .subscription_group:first-child span'
  );

  const subscribeTitle = document.querySelector(
    '.shopify_subscriptions_app_block .subscription_group:nth-child(2) .group_name'
  );

  if (oneTime) oneTime.classList.add('kr-sub-title');
  if (subscribeTitle) subscribeTitle.classList.add('kr-sub-title');
}

function addLayoutClass() {
  const layout = getSubscriptionLayout();
  const appBlock = document.querySelector('.shopify_subscriptions_app_block');

  if (!appBlock) return;

  appBlock.classList.remove('kr-layout-dog-size', 'kr-layout-frequency-only');

  if (layout === 'dog_size') {
    appBlock.classList.add('kr-layout-dog-size');
  }

  if (layout === 'frequency_only') {
    appBlock.classList.add('kr-layout-frequency-only');
  }
}

function addDogSizeClasses() {
  const layout = getSubscriptionLayout();

  const options = document.querySelectorAll(
    '.shopify_subscriptions_app_block .group_list_item input[data-radio-type="selling_plan"]'
  );

  options.forEach((input, index) => {
    const item = input.closest('.group_list_item');

    if (!item) return;

    item.classList.remove('kr-dog-small', 'kr-dog-medium', 'kr-dog-large');

    if (layout !== 'dog_size') return;

    if (index === 0) item.classList.add('kr-dog-small');
    if (index === 1) item.classList.add('kr-dog-medium');
    if (index === 2) item.classList.add('kr-dog-large');
  });
}

function addBenefitsGrid() {
  const groupList = document.querySelector(
    '.shopify_subscriptions_app_block .group_list'
  );

  if (!groupList) return;

  let benefits = document.querySelector('.kr-benefits');

  if (!benefits) {
    benefits = document.createElement('div');
    benefits.className = 'kr-benefits';
    groupList.insertAdjacentElement('afterend', benefits);
  }

  benefits.innerHTML = `
    <div class="kr-benefit">
      <img src="https://cdn.shopify.com/s/files/1/1002/0146/4120/files/Icon07.svg?v=1782173324" alt="">
      <p>${t('benefit1')}</p>
    </div>
    <div class="kr-benefit">
      <img src="https://cdn.shopify.com/s/files/1/1002/0146/4120/files/Icon08.svg?v=1782173324" alt="">
      <p>${t('benefit2')}</p>
    </div>
    <div class="kr-benefit">
      <img src="https://cdn.shopify.com/s/files/1/1002/0146/4120/files/Icon09.svg?v=1782173324" alt="">
      <p>${t('benefit3')}</p>
    </div>
    <div class="kr-benefit">
      <img src="https://cdn.shopify.com/s/files/1/1002/0146/4120/files/Icon10.svg?v=1782173324" alt="">
      <p>${t('benefit4')}</p>
    </div>
  `;
}

function addBestOfferBadge() {
  const title = document.querySelector(
    '.shopify_subscriptions_app_block .subscription_group:last-child .group_name'
  );

  if (!title) return;

  let badge = document.querySelector('.kr-best-offer');

  if (!badge) {
    badge = document.createElement('span');
    badge.className = 'kr-best-offer';
    title.insertAdjacentElement('afterend', badge);
  }

  badge.textContent = t('bestOffer');
}

function addSubscriptionPrice() {
  const wrapper = document.querySelector(
    '.shopify_subscriptions_app_block .subscription_group:last-child > .title_and_price_wrapper'
  );

  const subscriptionInput = document.querySelector(
    '.shopify_subscriptions_app_block input[data-radio-type="selling_plan"]'
  );

  if (!wrapper || !subscriptionInput) return;
  if (document.querySelector('.kr-subscription-price')) return;

  const currentPrice = subscriptionInput
    .getAttribute('data-variant-price')
    ?.replace(' MXN', '')
    ?.replace('$ ', '$');

  const oldPrice = subscriptionInput
    .getAttribute('data-variant-compare-at-price')
    ?.replace(' MXN', '')
    ?.replace('$ ', '$');

  const priceWrapper = document.createElement('div');
  priceWrapper.className = 'kr-subscription-price';

  priceWrapper.innerHTML = `
    ${oldPrice ? `<span class="kr-price-old">${oldPrice}</span>` : ''}
    ${currentPrice ? `<span class="kr-price-new">${currentPrice}</span>` : ''}
  `;

  wrapper.appendChild(priceWrapper);
}

function addMostPopularBadge() {
  const layout = getSubscriptionLayout();

  if (layout !== 'frequency_only') return;

  const secondOption = document.querySelectorAll(
    '.shopify_subscriptions_app_block .group_list .group_list_item'
  )[1];

  if (!secondOption) return;

  let badge = secondOption.querySelector('.kr-most-popular');

  if (!badge) {
    badge = document.createElement('div');
    badge.className = 'kr-most-popular';
    secondOption.appendChild(badge);
  }

  badge.textContent = t('mostPopular');
}

function cleanPriceLabels() {
  document.querySelectorAll('.in_widget_price').forEach((price) => {
    price.textContent = price.textContent
      .replace(' MXN', '')
      .replace('$ ', '$');
  });
}

function updateSubscriptionsWidget() {
  addLayoutClass();
  updateSubscriptionText();
  updateSubscriptionLabels();
  addDogWeightTitle();
  removeSubscriptionPolicy();
  addSubscriptionTextClasses();
  addDogSizeClasses();
  addBenefitsGrid();
  addBestOfferBadge();
  addSubscriptionPrice();
  addMostPopularBadge();
  cleanPriceLabels();
}

document.addEventListener('DOMContentLoaded', function () {
  updateSubscriptionsWidget();

  setTimeout(updateSubscriptionsWidget, 500);
  setTimeout(updateSubscriptionsWidget, 1000);
  setTimeout(updateSubscriptionsWidget, 2000);
  setTimeout(updateSubscriptionsWidget, 3000);
});